<!-- Sequences -->
<template>
  <Dialog>
    <div class="flex flex-col w-full h-full">
      <div class="flex flex-col w-full">
        <div class="flex justify-between items-center pl-5 pr-4 pt-3.5">
          <div class="flex items-center space-x-5">
            <div class="flex items-center space-x-2">
              <div class="flex items-center justify-center rounded-full h-5 w-5 bg-purple-light">
                <img src="/static/roundtable_icons/sequence_icon.svg" class="w-3 h-3 pl-0.5" />
              </div>
              <span class="font-manrope text-gray-800">Follow Up</span>
            </div>
            <div class="flex items-center space-x-2 font-manrope cursor-default">
              <img :src="`/static/roundtable_icons/${type}_icon_color.svg`" class="w-4 h-4" />
              <span v-if="type !== ''">{{ type === 'written' ? 'Written RoundTable' : 'Verbal RoundTable' }}</span>
            </div>
            <div class="flex items-center space-x-2.5 font-manrope text-gray-800 cursor-default">
              <img src="/static/roundtable_icons/courses_icon.svg" class=" w-3 -mt-0.5" />
              <span v-if=" course">{{ course.title }}</span>
            </div>
          </div>
          <div class="flex items-center space-x-5">
            <div v-if="isSaving" class="flex items-center space-x-2">
              <div class="flex items-center justify-center">
                <img src="/static/roundtable_icons/cloud-upload.svg" class="w-4 h-4"/>
              </div>
              <span class="font-manrope text-xs text-gray-800">Saving Changes...</span>
            </div>
            <button @click="handleCloseDialog()" class="w-7 h-7 focus:ring-2 focus:ring-offset-2 focus:ring-primary-dark rounded-full cursor-pointer bg-gray-50 hover:bg-gray-100 text-base flex items-center justify-center hover:text-gray-800 text-gray-700">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
        <div class="flex justify-between items-center px-5 relative w-full mb-2.5 mt-2.5">
          <div class="flex-grow">
            <input
              v-model="title"
              :disabled="isLoading"
              :placeholder="isLoading ? 'Loading...' : 'Enter a title...'"
              class="w-full text-3xl font-manrope font-bold text-gray-800 border-none bg-white py-1 outline-none"
            />
          </div>
          <div>
            <button @click="handleCreateRoundTable()" class="bg-primary hover:bg-primary-dark rounded-md border border-solid border-primary text-white py-1.5 px-4">
              Create
            </button>
          </div>
        </div>
        <div class="flex items-center justify-between w-full bg-white h-11 focus-within:border-pinky border-b  border-solid border-gray-200 pl-4 pr-5">
          <div class="flex items-center space-x-3 w-full font-manrope">
            <img src="/static/roundtable_icons/sparkles.svg" class="w-4 h-4"/>
            <input ref="genieRevise" v-model="revise.input" placeholder="How can I help you make this discussion prompt better?" class="w-full disabled:bg-white border-none"/>
          </div>
          <div class="flex items-center space-x-5">
            <pl-menu direction="right" :menuSize="3">
              <button slot="menu_trigger" class="flex items-center space-x-2.5 font-manrope text-gray-800">
                <span>{{ revise.mode }}</span>
                <i class="fa-solid fa-chevron-down text-xs text-gray-600 hover:text-gray-800"></i>
              </button>
              <ul class="flex flex-col space-y-1.5 rounded-lg mt-0.5 text-sm shadow-sm px-1 pt-0.5 pb-1 font-manrope max-h-96" menu-content>
                <li class="flex items-center space-x-1 justify-between hover:bg-gray-100 px-2.5 py-1 cursor-pointer rounded-md">
                  <span>Prompt</span>
                  <i v-if="revise.mode === 'Prompt'" class="fa-solid fa-check text-gray-400"></i>
                </li>
                <li class="flex justify-between space-x-1 text-gray-400 cursor-not-allowed items-center hover:bg-gray-100 px-2.5 py-1 rounded-md">
                  <span>Selection</span>
                  <i v-if="revise.mode === 'Selection'" class="fa-solid fa-check text-gray-400"></i>
                </li>
              </ul>
            </pl-menu>
            <button :disabled="revise.input === '' || revise.input.length < 4 ? true : false" class="text-white w-8 h-6 rounded-lg flex justify-center items-center disabled:opacity-50 bg-pinky hover:bg-pinky-dark cursor-pointer">
              <i class="fa-solid fa-arrow-right-long"></i>
            </button>
          </div>
        </div>
        <div v-if="isLoading === true || isGenerating === true" class='w-full'>
          <div class='h-0.5 w-full bg-pink-100 overflow-hidden'>
            <div class='progress w-full h-full bg-pink-500 left-right'></div>
          </div>
        </div>
      </div>
      <div class="flex-grow h-full w-full">
        <div v-if="type === 'written'" class="w-full h-full">
          <Editor
            :init="editor"
            api-key="no-api-key"
            v-model="written.prompt"
            ref="editorWrittenPrompt"
          />
        </div>
        <div v-if="type === 'verbal'" class="w-full h-full px-16 py-12">
          <div class="flex flex-col space-y-5 font-manrope mb-8">
            <h3 class="text-2xl text-gray-800 font-bold">
              Instructions
            </h3>
            <div v-if="isLoading === false" contenteditable="true" @blur="handleChangeInstructions" v-text="verbal.instructions" class="outline-none text-base">
            </div>
            <div v-else class="w-full">
              <div role="status" class="space-y-2.5 animate-pulse w-full">
                <div class="flex items-center w-full space-x-1">
                  <div class="h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32"></div>
                  <div class="h-3.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
                  <div class="h-3.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
                </div>
                <div class="flex items-center w-full space-x-1">
                  <div class="h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-full"></div>
                  <div class="h-3.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
                  <div class="h-3.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
                </div>
                <div class="flex items-center w-full space-x-1">
                  <div class="h-3.5 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
                  <div class="h-3.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-700 w-80"></div>
                  <div class="h-3.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-col space-y-5 font-manrope mb-8">
            <h3 class="text-2xl text-gray-800 font-bold">
              Content & Multimedia
            </h3>
            <div v-if="isLoading === false" class="flex items-center space-x-2 w-full">
              <input 
                class="w-full bg-gray-100 border border-solid rounded-md border-gray-200 py-1.5 px-3.5 focus-within:ring-2 ring-offset-2 ring-primary" 
                v-model="resource.name" 
                placeholder="Enter a Resource Name..."
              />
              <input 
                class="w-full bg-gray-100 border border-solid rounded-md border-gray-200 py-1.5 px-3.5 focus-within:ring-2 ring-offset-2 ring-primary" 
                v-model="resource.url"
                @keyup.enter="handleAddResource()" 
                placeholder="Enter a Resource URL..."
              />
              <button @click="handleAddResource()" :disabled="resource.name === '' && resource.url === '' ? true : false" class="disabled:opacity-50 bg-blueGray-800 rounded-md px-4 py-1.5 text-white">Add</button>
            </div>
            <div v-if="verbal.resources.length > 0 && isLoading === false" class="w-full">
              <ul class="flex flex-col">
                <Draggable
                  v-model="verbal.resources"
                  @start="isDragResource = true"
                  @end="isDragResource = false"
                  handle=".handle"
                  class="h-full flex-grow overflow-y-auto"
                >
                  <li v-for="(r, index) in verbal.resources" :key="index" class="flex items-center justify-between space-x-2 text-base mb-1 text-blue-600">
                    <div class="flex items-center space-x-2">
                      <button class="h-8 w-8 hover:bg-gray-100 rounded-full handle">
                        <i class="fa-solid fa-grip-vertical text-blueGray-600"></i>
                      </button>
                      <a :href="r.url" target="_blank" class="hover:underline">{{ r.name }}</a>
                      <i class="fa-solid fa-arrow-up-right-from-square text-blue-500" style="font-size:11px"></i>
                    </div>
                    <div class="flex items-center space-x-2">
                      <div 
                        @click="handleChangeResourceStatus(r.id)"
                        title="Hide Resource" 
                        class="w-8 cursor-pointer h-5 flex items-center bg-gray-200 rounded-full p-1 duration-300 ease-in-out"
                        :class="{ 'bg-primary': r.is_active }"
                      >
                        <div 
                          class="bg-white w-3 h-3 rounded-full transform duration-300 ease-in-out"
                          :class="{ 'translate-x-3': r.is_active }"
                          >
                        </div>
                      </div>
                      <button @click="handleDeleteResource(r.id)" title="Remove" class="flex items-center justify-center w-7 h-7 bg-gray-100 hover:bg-red-100 rounded-full text-red-500">
                        <i class="fa-solid fa-square-minus text-xs"></i>
                      </button>
                    </div>
                  </li>
                </Draggable>
              </ul>
            </div>
            <div v-if="isLoading === true">
              <div class="flex flex-col space-y-2.5 w-full animate-pulse">
                <div class="h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-6/12"></div>
                <div class="h-3.5 bg-gray-300 rounded-full dark:bg-gray-700 w-8/12"></div>
                <div class="h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-5/12"></div>
              </div>
            </div>
          </div>
          <div class="flex flex-col space-y-5 font-manrope">
            <div class="flex items-center justify-between">
              <h3 class="text-2xl text-gray-800 font-bold">
                Questions
              </h3>
            </div>
            <div v-if="isLoading === false" class="flex items-center space-x-2 w-full">
              <input 
                class="w-full bg-gray-100 border border-solid rounded-md border-gray-200 py-1.5 px-3.5 focus-within:ring-2 ring-offset-2 ring-primary" 
                v-model="question.question" 
                placeholder="Enter a Question..."
                @keyup.enter="handleAddQuestion()"
              />
              <button @click="handleAddQuestion()" :disabled="question.question === '' ? true : false" class="bg-blueGray-800 disabled:opacity-50 rounded-md px-4 py-1.5 text-white">Add</button>
            </div>
            <div v-if="verbal.questions.length > 0 && isLoading === false" class="w-full">
              <ul class="flex flex-col">
                <Draggable
                  v-model="verbal.questions"
                  @start="isDragQuestion = true"
                  @end="isDragQuestion = false"
                  handle=".handle-question"
                  class="h-full flex-grow overflow-y-auto"
                >
                  <li v-for="(q, index) in verbal.questions" class="flex justify-between items-center space-x-2 text-base mb-1.5">
                    <div class="flex items-center space-x-2 w-full">
                      <button class="h-8 w-8 hover:bg-gray-100 focus-within:outline-none rounded-full handle-question cursor-move">
                        <i class="fa-solid fa-grip-vertical text-blueGray-600"></i>
                      </button>
                      <input v-model="q.question" class="w-full border-none rounded"></input>
                    </div>
                    <div class="flex items-center space-x-3">
                      <div 
                        @click="handleChangeQuestionStatus(q.id)"
                        title="Hide Resource" 
                        class="w-8 cursor-pointer h-5 flex items-center bg-gray-200 rounded-full p-1 duration-300 ease-in-out"
                        :class="{ 'bg-primary': q.is_active }"
                      >
                        <div 
                          class="bg-white w-3 h-3 rounded-full transform duration-300 ease-in-out"
                          :class="{ 'translate-x-3': q.is_active }"
                          >
                        </div>
                      </div>
                      <button @click="handleDeleteQuestion(q.id)" title="Remove" class="flex items-center justify-center w-7 h-7 bg-gray-100 hover:bg-red-100 focus-within:border-red-500 focus-within:border focus-within:border-solid focus-within:outline-none rounded-full text-red-500">
                        <i class="fa-solid fa-square-minus text-xs"></i>
                      </button>
                    </div>
                  </li>
                </Draggable>
              </ul>
            </div>
            <div v-if="isLoading === true">
              <div class="flex flex-col space-y-2.5 w-full animate-pulse">
                <div class="h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-6/12"></div>
                <div class="h-3.5 bg-gray-300 rounded-full dark:bg-gray-700 w-10/12"></div>
                <div class="h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-6/12"></div>
                <div class="h-3.5 bg-gray-300 rounded-full dark:bg-gray-700 w-5/12"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Dialog>
</template>
<script>
  import Axios from 'axios';
  import Dialog from '../../components/Dialogs/Dialog.vue';
  import Editor from '@tinymce/tinymce-vue';
  import Draggable from 'vuedraggable';
  import { EditorOptions } from '../Drafts/EditorOptions';
  import { EventBus } from '../../utils/event-bus';
  import { GeneratingTemplate } from '../dashboard/NewRoundTable/Templates/Generating';
  /* import RoundtableService from 'features/onlineRoundtables/onlineRoundtables.services';
  import LiveDiscussionService from 'services/liveDiscussion'; */
  import { mapGetters } from 'vuex';
  export default {
    name: "SequencesIndex",
    components: {
      Editor,
      Dialog,
      Draggable
    },
    props: {
      id: {
        type: String,
        required: true
      },
      draftId: {
        type: String,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      course: {
        type: Object,
        required: false,
      },
      currentRoundtableType: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        title: "",
        currentRoundtable: null,
        followUpFromRoundtable: null,
        editor: EditorOptions,
        isLoading: false,
        isSaving: false,
        isGenerating: false,
        isDragResource: false,
        isDragQuestion: false,
        written: {
          prompt: "",
        },
        verbal: {
          instructions: "",
          questions: [],
          resources: []
        },
        revise: {
          mode: "Prompt",
          input: "",
          selection: ""
        },
        resource: {name: "", url: ""},
        question: { question: "", is_custom: null, is_active: null},
        draft: null,
      };
    },
    computed: {
      ...mapGetters([
        'getProfile',
      ]),
    },
    methods: {
      handleCloseDialog: async function() {
        if (this.title === "" || this.isLoading === true) {
          await Axios.delete(`/api/drafts/${this.draft.id}`);
        } else {
          await this.handleUpdateDraft();
        }
        await this.$store.dispatch('getRecentRoundtables');
        this.$router.replace({ query: {} });
        this.$emit('close');
      },
      handleChangeInstructions: function(event) {
        this.verbal.instructions = event.target.innerText;
      },
      handleAddResource: function() {
        if (this.resource.name === '' || this.resource.url === '') {
          EventBus.$emit('createToast', {type: "Error", message: "You need to set name and a valid url to add a resource", time: 5000});
          return;
        }

        this.verbal.resources.push({ id: this.verbal.resources.length, name: this.resource.name, url: this.resource.url, is_active: true });
        this.handleUpdateDraft();
        this.resource = { name: "", url: "", is_active: null };
      },
      handleDeleteResource: function(id) {
        const indexToDelete = this.verbal.resources.findIndex(item => item.id === id);
        if (indexToDelete !== -1) {
          this.verbal.resources.splice(indexToDelete, 1);
        }
      },
      handleChangeResourceStatus: function(id) {
        const resource_object = this.verbal.resources.find((obj, index) => index === id);
        this.verbal.resources.find((obj, index) => index === id).is_active = !resource_object.is_active;
      },
      handleAddQuestion: function() {
        if (this.question.question === '') {
          return;
        }
        this.verbal.questions.push({id: this.verbal.questions.length, question: this.question.question, is_active: true, is_custom: true });
        this.question = { question: "", is_active: null, is_custom: null };
      },
      handleDeleteQuestion: function(id) {
        const indexToDelete = this.verbal.questions.findIndex(item => item.id === id);
        if (indexToDelete !== -1) {
          this.verbal.questions.splice(indexToDelete, 1);
        }
      },
      handleChangeQuestionStatus: function(id) {
        const resource_object = this.verbal.questions.find((obj, index) => index === id);
        this.verbal.questions.find((obj, index) => index === id).is_active = !resource_object.is_active;
      },
      handleGenerateWrittenFollowUpPrompt: async function() {
        try {
          this.isGenerating = true;
          const response = await Axios.get(`/api/sequences/v1/generate_follow_up/written/${this.id}`);
          if (!response) {
            throw new Error('It was not possible generate a follow up prompt...');
          }
          this.written.prompt = response.data.follow_up_prompt;
          this.isGenerating = false;

        } catch (error) {
          console.error(error);
        }
      },
      handleGenerateVerbalFollowUpPrompt: async function() {
        try {
          this.isGenerating = true;
          const response = await Axios.get(`/api/sequences/v1/generate_follow_up/verbal/${this.id}`);
          if (!response) {
            throw new Error('It was not possible generate a follow up prompt...');
          }
          this.verbal.instructions = response.data.instructions;
          this.verbal.questions = response.data.follow_up_questions;
          this.isGenerating = false;

        } catch (error) {
          console.error(error);
        }
      },
      handleGenerateFollowUp: async function() {
        try {
          const response = await Axios.get(`/api/sequences/v1/generate/follow/up/${this.currentRoundtableType}/${this.id}/${this.draft.type}`);
          this.title = response.data.title;
          if (this.draft.type === 'written') {
            this.written.prompt = response.data.template;
          }
          if (this.draft.type === 'verbal') {
            this.verbal.instructions = response.data.summary;
            this.verbal.questions = response.data.questions;
          }
        } catch (error) {
          console.error(error);
        }
      },
      handleUpdateDraft: async function() {
        try {
          this.isSaving = true;
          const payload = { 
            title: this.title, 
            prompt: this.written.prompt, 
          };
          await Axios.put(`/api/drafts/${this.draftId}`, payload);
          this.isSaving = false;
        } catch (error) {
          console.error(error);
        }
      },
      handleCreateSequence: async function() {
        try {
          console.log(this.followUpFromRoundtable);
          const is_roundtable_in_sequence = this.followUpFromRoundtable.sequence_id === null ? false : true;
          let users_invited = [];
          let created_sequence_id = null;
          if (!is_roundtable_in_sequence) {
            const payload = {
              title: this.followUpFromRoundtable.title + ' - Sequence',
              course_id: this.followUpFromRoundtable.course_id,
              author_id: this.getProfile.id,
              previous_roundtable_id: this.followUpFromRoundtable.id,
              previous_roundtable_type: this.followUpFromRoundtable.type,
            };
            console.log(payload, users_invited, created_sequence_id);
          }
        } catch (error) {
          console.error(error);
        }
      },
      handleCreateRoundTable: async function() {
        try {
          await this.handleCreateSequence();
          /*  */
        } catch (error) {
          console.error(error);
        }
      }
    },
    mounted: async function() {
      this.isLoading = true;
      const draft = await Axios.get(`/api/drafts/${this.draftId}`);
      this.draft = draft.data;

      if (this.currentRoundtableType === 'written') {
        const roundtable = await this.$store.dispatch('fetchRoundtable', this.id);
        this.followUpFromRoundtable = roundtable;
      }

      if(this.currentRoundtableType === 'verval') {
        const roundtable = await this.$store.dispatch('fetchLiveDiscussion', this.id);
        this.followUpFromRoundtable = roundtable;
      }

      if (this.draft.type === 'written') {
        this.written.prompt = GeneratingTemplate;
      }
      
      await this.handleGenerateFollowUp();
      this.isLoading = false;
      
      /* this.isLoading = false;
      const follow_number = this.previousRoundtable.roundtables_sequence.length === 0 ? 1 : this.previousRoundtable.roundtables_sequence.length;
      this.title = `${this.previousRoundtable.title} - Follow Up (${follow_number})`; */
    }
  };
</script>
<style scoped>

  .progress {
    animation: progress 1s infinite linear;
  }

  .left-right {
    transform-origin: 0% 50%;
  }
  @keyframes progress {
    0% {
      transform:  translateX(0) scaleX(0);
    }
    40% {
      transform:  translateX(0) scaleX(0.4);
    }
    100% {
      transform:  translateX(100%) scaleX(0.5);
    }
  }
  .loader,
  .loader:after {
    border-radius: 50%;
    width: 16px;
    height: 16px;
    margin-top: 1px;
  }
  .loader {
    border-top: 3px solid rgba(255, 255, 255, 0.2);
    border-right: 3px solid rgba(255, 255, 255, 0.2);
    border-bottom: 3px solid rgba(255, 255, 255, 0.2);
    border-left: 3px solid #ffffff;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;
  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>


// WEBPACK FOOTER //
// Index.vue?3e5a1fe6